import { useBlocksConfig } from "@pathwright/blocks-engine"
import { SubText } from "@pathwright/blocks/src/shared"
import PropTypes from "prop-types"
import { getFeedback } from "./edit"
import { FeedbackContainer } from "./ui"

const FeedbackView = ({ feedbackList, style }) => {
  const feedback = getFeedback(feedbackList)
  const { templateVariables } = useBlocksConfig()

  return (
    <div style={{ width: "100%", ...style }} className="FeedbackView">
      {feedback ? (
        <FeedbackContainer>
          <div style={{ width: "100%" }}>
            <SubText html={feedback.html} templateContext={templateVariables} />
          </div>
        </FeedbackContainer>
      ) : null}
    </div>
  )
}

FeedbackView.propTypes = {
  feedbackList: PropTypes.arrayOf(PropTypes.object),
  style: PropTypes.object
}

export default FeedbackView
